import { WSService } from "../../utils/WSService";

export const serviceSharedFiles = new WSService("/shared-files");
